import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const EconomicInformation = ({
  refIncomeOfHumanPerson,
  refTotal_indebtedness_of_the_financial_systemHuman,
  refTotal_monthly_commitment_of_the_financial_systemHuman,
  refCurrent_status_with_BCRAHuman,
}) => {
  const data = useLocation();
  const [economicInformation, setEconomicInformation] = useState({
    income: data.state.data.EconomicInformation.IncomeOfHumanPerson || "",
    totalIndebtednessOfTheFinancialSystem:
      data.state.data.EconomicInformation
        .total_indebtedness_of_the_financial_system || "",
    totalmMnthlyFinancialSystemCommitment:
      data.state.data.EconomicInformation
        .total_monthly_commitment_of_the_financial_system || "",
    currentSituationBeforeBCRA:
      data.state.data.EconomicInformation.current_status_with_BCRA || "",
  });

  return (
    <div className="section">
      <div className="tittleupdatebox">
        <p className="tittleupdate">Informacion Economica</p>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Monto transaccional anual:
          </label>
          <input
            ref={refIncomeOfHumanPerson}
            className="inputupdate"
            type="text"
            defaultValue={economicInformation.income}
            onChange={(e) =>
              setEconomicInformation({
                ...economicInformation,
                income: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Total de endeudamiento del sistema financiero:
          </label>
          <input
            ref={refTotal_indebtedness_of_the_financial_systemHuman}
            className="inputupdate"
            type="text"
            defaultValue={
              economicInformation.totalIndebtednessOfTheFinancialSystem
            }
            onChange={(e) =>
              setEconomicInformation({
                ...economicInformation,
                totalIndebtednessOfTheFinancialSystem: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Total de compromiso mensual sistema financiero:
          </label>
          <input
            ref={refTotal_monthly_commitment_of_the_financial_systemHuman}
            className="inputupdate"
            type="text"
            defaultValue={
              economicInformation.totalmMnthlyFinancialSystemCommitment
            }
            onChange={(e) =>
              setEconomicInformation({
                ...economicInformation,
                totalmMnthlyFinancialSystemCommitment: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Situación vigente ante Bcra:
          </label>
          <input
            ref={refCurrent_status_with_BCRAHuman}
            className="inputupdate"
            type="text"
            defaultValue={economicInformation.currentSituationBeforeBCRA}
            onChange={(e) =>
              setEconomicInformation({
                ...economicInformation,
                currentSituationBeforeBCRA: e.target.value,
              })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default EconomicInformation;
